export class ConfigurationValidationError extends Error {
  invalidProps: Array<string>;
  constructor(invalidProps: Array<string>) {
    super(`Configuration failed validation. Invalid properties:\n${invalidProps.join("\n")}`);
    this.invalidProps = invalidProps;
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
  }
}
